exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty[data-v-4417eef2] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.empty__message[data-v-4417eef2] {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n.empty__message i[data-v-4417eef2] {\n      color: #bcf2db;\n      font-size: 30px;\n}\n.empty__message span[data-v-4417eef2] {\n      color: #777;\n      font-size: 16px;\n}\n", ""]);

// exports
